/* Una caja de herramientas de chapa, en foto.
 *
 * Igna, 02/10: el estante como una estantería de metal con cajas de colores.
 * Primero se dibujaron en SVG; después Igna generó la foto de una caja roja
 * gastada y las piezas del estante (viga y parante), igual que se hizo con
 * las fotos de las herramientas.
 *
 * ── CINCO CAJAS, UNA POR EMPRESA Y LA SIN PINTAR ───────────────────────────
 *
 * La roja, la azul, la verde y la púrpura son fotos que generó Igna con la
 * misma toma; la galvanizada es la roja con la pintura recoloreada (óxido,
 * traba y bordes como en el original). A todas se les sacó el fondo y se les
 * tapó la etiqueta de papel que traían, chica para un nombre: la chapita la
 * pone la pantalla, más grande.
 *
 * El color sale de la empresa de la persona (`aspectoDeCaja`): TA verde, TC
 * azul, EX roja, TCC púrpura; sin empresa, galvanizada.
 *
 * ── LOS COLORES NO SIGUEN AL TEMA ───────────────────────────────────────────
 *
 * Igual que la pared del pañol: es un objeto del taller. Una caja roja es
 * roja en tema claro y en oscuro.
 */

import roja from "../../assets/cajas/caja_roja.webp";
import azul from "../../assets/cajas/caja_azul.webp";
import verde from "../../assets/cajas/caja_verde.webp";
import purpura from "../../assets/cajas/caja_purpura.webp";
import galvanizada from "../../assets/cajas/caja_galvanizada.webp";

export const FOTOS_CAJA = { roja, azul, verde, purpura, galvanizada };

export default function CajaDibujo({ color = "roja" }) {
  return (
    <img className="hrr-cajita-img" src={FOTOS_CAJA[color] || roja}
         alt="" aria-hidden="true" draggable="false"
         width="480" height="282" loading="lazy" decoding="async" />
  );
}
